import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { CappedPensionArrangementsFlexiConversionAvailabilitiesDispatcher } from "./Variable";

export interface CappedPensionArrangementsFlexiConversionAvailabilitiesStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class CappedPensionArrangementsFlexiConversionAvailabilitiesStatic extends BaseStore<CappedPensionArrangementsFlexiConversionAvailabilitiesStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(CappedPensionArrangementsFlexiConversionAvailabilitiesDispatcher, (actionData) => this.onCappedPensionArrangementsFlexiConversionAvailabilitiesStoreResponse(actionData));
    }

    public getLastResult(): CappedPensionArrangementsFlexiConversionAvailabilitiesStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): CappedPensionArrangementsFlexiConversionAvailabilitiesStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onCappedPensionArrangementsFlexiConversionAvailabilitiesStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionTyped });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
